import React from "react";
import { Box, Stack, Typography } from "@mui/material";

export default function LoginBanner({ logoSrc }: { logoSrc?: string }) {
  return (
    <Box
  sx={{
    height: "100%",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    px: 4,
    pt: 4,
    pb: 3,
    background: `
      linear-gradient(180deg, rgba(75,79,80,0.92), rgba(36,40,41,0.98)),
      linear-gradient(135deg, #6B7070 0%, #242829 72%, #B84B00 100%)
    `,
  }}
>
  <Stack
    spacing={2}
    sx={{
      alignItems: "flex-start",
      justifyContent: "flex-start",
      width: "100%",
      maxWidth: 440,
    }}
  >
        <Stack direction="row" spacing={2} alignItems="center">
          {logoSrc && (
            <Box
              component="img"
              src={logoSrc}
              sx={{ width: 56, height: 56, objectFit: "contain" }}
            />
          )}

          <Typography sx={{ fontWeight: 800, fontSize: 14, letterSpacing: 0.5 }}>
            K-FRONTIERS LIMITED
          </Typography>
        </Stack>

        <Typography
          sx={{
            fontSize: 30,
            fontWeight: 800,
            lineHeight: 1.2,
            maxWidth: 420,
          }}
        >
          Commercial, customer, and inventory management platform
        </Typography>

        <Typography
          sx={{
            fontSize: 14,
            opacity: 0.85,
            maxWidth: 420,
          }}
        >
          Secure internal portal
        </Typography>
      </Stack>
    </Box>
  );
}
